import * as firebase from 'firebase/app'
import React, { useCallback, useState } from 'react'
import { Redirect } from 'react-router-dom'
import withFirebaseAuth from 'react-with-firebase-auth'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { Box, Button, Form, Main, Header, Heading, Paragraph } from 'grommet'
import { Github, FacebookOption, Google, Twitter } from 'grommet-icons'

import { firebaseApp, firebaseAppAuth } from '../Firebase/FirebaseApp'
import '../Login/Login.css'

const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
  facebookProvider: new firebase.auth.FacebookAuthProvider(),
  githubProvider: new firebase.auth.GithubAuthProvider(),
  twitterProvider: new firebase.auth.TwitterAuthProvider()
}

const Login = ({
  history,
  signInWithGoogle,
  signInWithFacebook,
  signInWithTwitter,
  signInWithGithub,
  user
}) => {
  const MySwal = withReactContent(Swal)
  const [showPassword, setShowPassword] = useState(false)

  const handleSignUp = useCallback(
    async (event) => {
      event.preventDefault()
      const { email, password } = event.target.elements
      try {
        await firebaseApp.auth().signInWithEmailAndPassword(email.value, password.value)
        history.push('/')
      } catch (error) {
        MySwal.fire({
          icon: 'error',
          title: <p>Error</p>,
          html: <p>{error.message}</p>,
          position: 'top'
        })
      }
    },
    [history, MySwal]
  )

  const switchPassword = () => setShowPassword(!showPassword)

  if (user) {
    return <Redirect to={'/'} />
  }
  return (
    <Main
      style={{
        background: 'rgba(0, 0, 0, 0.1)'
      }}
    >
      <Box
        style={{
          height: 'calc(100vh - 30px)',
          display: 'grid',
          gridTemplateRows: '1fr 6fr 1fr',
          paddingBottom: '60px'
        }}
      >
        <Header style={{ justifyContent: 'center' }} background="brand" pad="medium">
          <Heading>Login</Heading>
        </Header>
        <Box
          margin={{ vertical: 'large', horizontal: 'medium' }}
          style={{
            background: 'white',
            boxShadow: '0 0 10px 2px rgba(0,0,0,.2)'
          }}
        >
          <Box pad="large" style={{ borderBottom: '1px solid #f1f1f1' }}>
            <Paragraph pad={{ vertical: 'medium' }} size="small" alignSelf="center">
              Enter your email and password to login
            </Paragraph>
          </Box>
          <Form onSubmit={handleSignUp} style={{ display: 'grid' }}>
            <Box pad="medium" style={{ borderBottom: '1px solid #f1f1f1' }}>
              <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>EMAIL:*</span>
              <input
                name="email"
                type="email"
                placeholder="your@email.com"
                style={{ border: 'none' }}
              />
            </Box>
            <Box
              pad="medium"
              style={{
                borderBottom: '1px solid #f1f1f1',
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <Box style={{ width: '100%' }}>
                <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>PASSWORD:*</span>
                <input
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  style={{ border: 'none' }}
                />
              </Box>
              <Box
                style={{
                  justifyContent: 'center',
                  padding: '10px 15px',
                  borderLeft: '1px solid #f1f1f1'
                }}
                onClick={switchPassword}
              >
                <span>Show</span>
              </Box>
            </Box>
            <Box pad="medium" style={{ borderBottom: '1px solid #f1f1f1' }}>
              <Button
                type="submit"
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  width: '50%',
                  textAlign: 'center',
                  padding: '10px 15px',
                  fontWeight: 'bold',
                  margin: '0 0 0 auto'
                }}
              >
                Login
              </Button>
            </Box>
          </Form>

          <Box
            className="social-login"
            style={{ background: '#CA3326' }}
            onClick={signInWithGoogle}
          >
            <div className="social-icon" style={{ background: '#EA4335' }}>
              <Google color="white" />
            </div>
            <Button className="social-text">Login with Google</Button>
          </Box>
          <Box
            className="social-login"
            style={{ background: '#3b5998' }}
            onClick={signInWithFacebook}
          >
            <div className="social-icon" style={{ background: '#1877f2' }}>
              <FacebookOption color="white" />
            </div>
            <Button className="social-text">Login with Facebook</Button>
          </Box>

          <Box
            className="social-login"
            style={{ background: '#1da1f2' }}
            onClick={signInWithTwitter}
          >
            <div className="social-icon" style={{ background: '#2eafff' }}>
              <Twitter color="white" />
            </div>
            <Button className="social-text">Login with Twitter</Button>
          </Box>
          <Box
            className="social-login"
            style={{ background: '#24292e' }}
            onClick={signInWithGithub}
          >
            <div className="social-icon" style={{ background: '#4c5761' }}>
              <Github color="white" />
            </div>
            <Button className="social-text">Login with Github</Button>
          </Box>
        </Box>
        <Box pad="large">
          <Paragraph size="small">
            Signing up does not allow us to contact you. By signing up you agree to the{' '}
            <a
              href="https://oauth.net/articles/authentication/"
              target="_blank"
              rel="noopener noreferrer"
            >
              OAuth terms
            </a>
          </Paragraph>
        </Box>
      </Box>
    </Main>
  )
}

export default withFirebaseAuth({
  providers,
  firebaseAppAuth
})(Login)
